app.service('productCardManager', function () {

	let cart = {
		partnerSubscription: [], // [{id, groupId}]
		services: [],
		servicesOrder: [],
		productWarranty: {
			warranty: undefined,
			warrantyPaymentType: undefined,
			warrantyAddedFrom: undefined,
		},
		lastSelectedWarrantyPaymentType: undefined,
		lastSelectedWarrantyId: undefined,
		lastSelectedWarrantyAddedFrom: undefined,
	};

	function togglePartnerSubscription(id, groupId) {
		assertNumber(id);
		assertNumber(groupId);

		if (hasPartnerSubscription(id)) {
			cart.partnerSubscription = cart.partnerSubscription.filter(item => item.id !== id);
		} else {
			cart.partnerSubscription.push({
				id,
				groupId
			});
		}
	}

	function hasPartnerSubscription(partnerSubscriptionId) {
		assertNumber(partnerSubscriptionId);
		return cart.partnerSubscription.find(item => item.id === partnerSubscriptionId) !== undefined;
	}

	function hasAnyPartnerSubscription(groupId) {
		assertNumber(groupId);
		return cart.partnerSubscription.filter(item => item.groupId === groupId).length > 0;
	}

	function emptyPartnerSubscription(groupId) {
		assertNumber(groupId);
		cart.partnerSubscription = cart.partnerSubscription.filter(item => item.groupId !== groupId);
	}

	function addService(serviceId) {
		assertNumber(serviceId);
		cart.services.push(serviceId);
	}

	function removeService(serviceId) {
		assertNumber(serviceId);
		cart.services = cart.services.filter(id => id !== serviceId);
	}

	function hasService(serviceId) {
		assertNumber(serviceId);
		return cart.services.indexOf(serviceId) > -1;
	}

	function addServiceToOrder(serviceId) {
		assertNumber(serviceId);
		cart.servicesOrder.push(serviceId);
	}

	function hasServiceInOrder(serviceId) {
		assertNumber(serviceId);
		return cart.servicesOrder.indexOf(serviceId) > -1;
	}

	function addWarranty(warranty, warrantyPaymentType, warrantyAddedFrom) {
		assertNumber(warranty);
		cart.productWarranty = {
			warranty,
			warrantyPaymentType,
			warrantyAddedFrom,
		};
	}

	function hasWarranty() {
		return !!cart.productWarranty.warranty;
	}

	function removeWarranty() {
		cart.productWarranty = {
			warranty: undefined,
			warrantyPaymentType: undefined,
			warrantyAddedFrom: undefined
		};
	}

	function assertNumber(identifier) {
		if (typeof identifier !== "number") {
			throw new TypeError("identifier must be a number");
		}
	}

	function setUserWarrantyPaymentType(type) {
		cart.lastSelectedWarrantyPaymentType = type;
	}

	function setUserWarranty(warrantyId) {
		cart.lastSelectedWarrantyId = warrantyId;
	}

	function setUserWarranty(warrantyAddedFrom) {
		cart.lastSelectedWarrantyAddedFrom = warrantyAddedFrom;
	}

	function clearLastSelectedWarranty() {
		cart.lastSelectedWarrantyPaymentType = undefined;
		cart.lastSelectedWarrantyId = undefined;
	}

	function setLastSelectedWarranty(type, warrantyId) {
		setUserWarrantyPaymentType(type);
		setUserWarranty(warrantyId);
		setUserWarrantyAddedFrom(warrantyAddedFrom);
	}

	function empty() {
		cart.partnerSubscription = [];
		cart.services = [];
		cart.servicesOrder = [];
		clearLastSelectedWarranty();
		removeWarranty();
	}

	return {
		togglePartnerSubscription,
		emptyPartnerSubscription,
		hasPartnerSubscription,
		hasAnyPartnerSubscription,
		addService,
		removeService,
		hasService,
		addServiceToOrder,
		hasServiceInOrder,
		addWarranty,
		hasWarranty,
		removeWarranty,
		setUserWarrantyPaymentType,
		setUserWarranty,
		empty,
		clearLastSelectedWarranty,
		setLastSelectedWarranty,
		get: () => Object.freeze(Object.assign({}, cart))
	};
});